import GatewayRetailerLookupAutocomplete from "./GatewayRetailerLookupAutocomplete";

const MissingRetailerLookupFilter = ({ retailerId, retailerLabel, onRetailerChange }) => (
  <GatewayRetailerLookupAutocomplete
    retailerId={retailerId}
    inputSeedLabel={retailerLabel}
    onSelect={(option) => {
      onRetailerChange({
        id: option?.id || "",
        label: option?.label || "",
      });
    }}
    onClear={() => onRetailerChange({ id: "", label: "" })}
    label="Retailer (lookup)"
    sx={{ minWidth: 260 }}
  />
);

export default MissingRetailerLookupFilter;
